import { __exports as r } from "../../../../_virtual/is-array.js";
Object.defineProperty(r, "__esModule", { value: !0 });
r.isArray = void 0;
r.isArray = Array.isArray || function(e) {
  return Object.prototype.toString.call(e) === "[object Array]";
};
export {
  r as default
};
